import { render } from "./Dorm.vue?vue&type=template&id=6a3327a5&scoped=true"
import script from "./Dorm.vue?vue&type=script&lang=js"
export * from "./Dorm.vue?vue&type=script&lang=js"

import "./Dorm.vue?vue&type=style&index=0&id=6a3327a5&scoped=true&lang=css"

import exportComponent from "/vercel/path0/Web_Apps/Dorm_Review/WebUI/UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a3327a5"]])

export default __exports__